export default {
    子分类: "Subcategory",
    商品图号: "Product Code",
    查看详情: "Details",
    图号: "Code",
    加入购物车: "Add to Cart",
    首页: "Home",
    确认退出吗: "Confirm Logout?",
    确认: "Confirm",
    取消: "Cancel",
    我的订单: "My Orders",
    购物车: "Cart",
    总分类: "Categories",
    更多: "More",
    默认排序: "Default Sort",
    价格排序: "Price Sort",
    暂无数据: "No Data",
    请输入要查询的单号: "Enter Order Number",
    查询: "Search",
    最近一周: "Last Week",
    最近一个月: "Last Month",
    最近三个月: "Last 3 Months",
    所有日期: "All Dates",
    至: "To",
    确定删除本条商品吗: "Delete Item",
    删除: "Delete",
    已选择: "Selected",
    件: "Items",
    商品合计: "Total",
    下单结算: "Checkout",
    商品信息: "Product Info",
    单价: "Price",
    数量: "Qty",
    小计: "Subtotal",
    操作: "Action",
    共: "Total",
    件商品: "Items",
    验证码必须为数字: "Code Must Be Numeric",
    手机号必须为数字: "Phone Must Be Numeric",
    手机号必须为字母或数字: "Phone Must Be Alphanumeric",
    账号不能为空: "Account Required",
    密码不能为空: "Password Required",
    请输入密码: "Enter Password",
    请输入手机号: "Enter Phone",
    用户登录: "Login",
    退出登录: "Logout",
    登录中: "Logging In",
    获取验证码: "Get Code",
    手机号不能为空: "Phone Required",
    请输入关键字: "Please enter a keyword",
    请输入内容: "Please enter content",
    订单编号: "Order Number",
    合计: "Total",
    未审核: "Unreviewed",
    下单时间: "Order Time",
    适用车型: "Applicable Models",
    详情咨询: "Details Consultation",
    描述文字: "Description Text",
    商品详情: "Product Details",
    商品名称: "Product Name",
    商品规格: "Product Specifications",
    外文名称: "Foreign Name",
    商品尺寸: "Product Dimensions",
    商品体积: "Product Volume",
    商品重量: "Product Weight",
    欢迎来到: "Welcome to",
    网站: "Website",
    俄文: "Russian",
    英文: "English",
    中文: "Chinese",
    商品序号: "Sku",
    俄文名称: "Russian Name",
    英文名称: "English Name",
    暂无图片: "No Image",
    重置: "Reset",
    批量删除: "Bulk Delete",
    请输入商品名称: "Enter Product Name",
    今日: "Today",
    昨日: "Yesterday",
    本周: "This Week",
    本年: "This Year",
    本月: "This Month",
    已审核: "Approved",
    备注: "Notes",
    修改: "Edit",
    备注信息: "Notes Information",
    保存: "Save",
    该单据已审核请联系管理员: "This document has been approved, please contact the administrator.",
    密码登录: "Login",
    手机号: "Phone number",
    密码: "Password",
    登录账号: "Login",
}